var _path, _path2, _path3, _path4, _path5, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriggerShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9833_6185)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9833_6185",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9833_6185)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9833_6185",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9833_6185)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_9833_6185",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_9833_6185)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0Z",
    fill: "url(#paint0_linear_9833_6185)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_9833_6185",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 5,
    width: 7,
    height: 14
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5H8V19H15V5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_9833_6185)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.579 10.2278H11.7997L12.9596 5.43731C12.9811 5.3018 12.9381 5.16839 12.85 5.11309C12.8285 5.08643 12.7854 5.08643 12.7621 5.08643C12.6974 5.08643 12.631 5.13987 12.5879 5.19517L8.1031 13.286C8.05999 13.366 8.05999 13.4748 8.08152 13.5569C8.12638 13.6369 8.19095 13.6903 8.27903 13.6903H10.9686L9.76572 18.5607C9.74419 18.6962 9.78899 18.8317 9.87527 18.887C9.89685 18.9137 9.94165 18.9137 9.96318 18.9137C10.0296 18.9137 10.0943 18.8602 10.1374 18.8049L14.7533 10.6343C14.7749 10.5788 14.7982 10.5256 14.7982 10.4721C14.7982 10.3366 14.6886 10.2278 14.579 10.2278Z",
    fill: "white"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9833_6185",
    x1: 6.38905,
    y1: 4.62037,
    x2: 19.6121,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#665DFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E274D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9833_6185"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriggerShort);
export default __webpack_public_path__ + "static/media/Trigger-Short.c26475d5a6b4b12b4b57c5f22751ca13.svg";
export { ForwardRef as ReactComponent };